/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "@/src/components/Container/Container";
import HeadlineSection from "@/src/components/Sections/Generic/HeadlineSection/HeadlineSection";
import Typography from "@mui/material/Typography";

const WayWeWorkSection = () => {
  return (
    <Container variant={"sm"}>
      <HeadlineSection headline={"Bei Legalbird arbeiten"} />
      <Typography sx={{ padding: 0, textAlign: { xs: "left", md: "center" } }}>
        Wir sind ein starkes Team aus <strong>Rechtsexpertinnen</strong>, <strong>Rechtsexperten</strong> und <strong>IT-Profis</strong> mit dem Anspruch, für
        jeden Fall die bestmögliche Lösung zu finden. Unterstütz uns dabei, den Rechtsmarkt durch Expertise und smarte, sichere Technologie auf das nächste
        Level zu bringen. <br />
        <strong>Wir freuen uns darauf, dich kennenzulernen!</strong>
      </Typography>
    </Container>
  );
};

export default WayWeWorkSection;
